import type { FreezeOnMessage } from '@module/types/centrifuge/public-message/freezeMessageTypes';

function constructFreezeOnPayload(
  { name, messageType }: { name: string; messageType?: 'now' | 'past' } = { name: '', messageType: 'now' },
): FreezeOnMessage {
  return {
    data: {
      type: 'FreezeOn',
      message: { name, messageType },
    },
    offset: Date.now(),
  } as FreezeOnMessage;
}

export default constructFreezeOnPayload;
